exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html {\n  font-size: 100%;\n}\n\nbody {\n  margin: 0;\n  padding: 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Helvetica, Arial, sans-serif;\n  font-size: 1rem;\n  line-height: 1.5;\n  height: 100%;\n}\n\nbutton:disabled {\n  opacity: 0.5;\n}\n\n#app div {\n  height: 100%;\n}\n", ""]);

// exports
